const PRoWStatusCode = [
  {
    id: "A",
    gpText: "Under appeal",
  },
  {
    id: "C",
    gpText: "Under consultation",
  },
  {
    id: "D",
    gpText: "Temporary Diversion",
  },
  {
    id: "E",
    gpText: "Extinguished",
  },
  {
    id: "O",
    gpText: "Open and approved",
  },
  {
    id: "P",
    gpText: "Permissive",
  },
];

export default PRoWStatusCode;